var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsuario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B0B0B0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.828 17.847A7.986 7.986 0 0 0 12 14a7.985 7.985 0 0 0-6.828 3.847A8.947 8.947 0 0 1 3 12c0-4.963 4.037-9 9-9s9 4.037 9 9a8.947 8.947 0 0 1-2.172 5.847M12 1C5.925 1 1 5.925 1 12c0 3.076 1.266 5.854 3.301 7.85a10.957 10.957 0 0 0 7.7 3.15c2.998 0 5.714-1.203 7.698-3.15A10.962 10.962 0 0 0 23 12c0-6.075-4.925-11-11-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuario);
export default __webpack_public_path__ + "static/media/usuario.20e1aaf25acab48aaa7636cfed97d70e.svg";
export { ForwardRef as ReactComponent };